import { ClientNode } from '../../../model/client-model/client-node';
import { ModelType } from '../../../model/client-model/properties/model-type';

/**
 * Returns true if a custom model has been selected.
 * Note: Will return true even if the model isn't active.
 * @see {@link holdsActiveCustomModel} which takes the model into account.
 * @param node
 * @returns
 */
export function holdsCustomModel(node: ClientNode): boolean {
  return node?.nodeProperties?.modelType === ModelType.CUSTOM;
}
